import React, { Component } from 'react';
import { connect } from 'react-redux';

import ReactPaginate from 'react-paginate';
import queryString from 'query-string';

import Spinner from '../../components/generics/Spinner';

import { STARTING_PAGE } from '../../constants/constants';

import {
  fetchPendingInventoryList,
  fetchPendingInventoryListSuccess,
  fetchPendingInventoryListFailure,
} from "../../store/pendingInventory/actions";

import PendingInventoryList from '../../components/pendingInventory/PendingInventoryList'
import ListHeader from '../../components/generics/ListHeader';
import SearchInventoryBar from '../../components/generics/SearchInventoryBar';
import { withRouter } from "utils/WithRouter";

export class PendingInventoryListContainer extends Component {
  constructor(props){
    super(props);

    this.state = {
      page: 1,
    };
  }

  componentDidMount() {
    const params = queryString.parse(this.props.location.search);
    const page = params.page ? params.page : STARTING_PAGE;

    this.setState({ page }, () => {
      this.props.fetchPendingInventories(page);
    });
  }

  // ---------------------------------------------------------------------------
  // Filters
  // ---------------------------------------------------------------------------

  filterList = () => {
    let params = {};
    params.page = this.state.page;

    this.props.history.push({
      search: queryString.stringify(params)
    });
    this.props.fetchPendingInventories(this.state.page);
  }

  // ---------------------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------------------
  handlePageRequest = (data) => {
    let page = data.selected + 1;
    if(page !== this.state.page){
      this.setState({ page }, () => {
          this.filterList();
      });
    };
  }

  handleInventoryScanned = (id) => {
    this.props.history.push(`/pending_inventory/${id}`);
  }

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    if(!this.props.pendingInventories.inventories){
      return(
        <Spinner />
      )
    }
    return (
      <div className="animated fadeIn">
        <div className="card">
          <ListHeader title="Pending Inventory" iconClass="fa fa-tasks mr-05" showAction={false} />
          <SearchInventoryBar
            forPendingInventory
            goToInventory={(id) => {this.handleInventoryScanned(id)}}
            autoFocus
          />
        </div>
        <div className="card">
          <div className="card-block p-0">
            <table className="table table-striped table-bordered datatable mb-0">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Item</th>
                  <th>
                    <span className="hidden-xs-down">Manufacturer</span>
                    <span className="hidden-sm-up">Mfr.</span>
                  </th>
                  <th className="hidden-xs-down">Grade</th>
                  <th className="hidden-xs-down">Pieces</th>
                  <th className="hidden-xs-down">Price</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <PendingInventoryList
                inventories={this.props.pendingInventories.inventories}
              />
            </table>
            {this.props.pendingInventories.pages > 1 &&
              <ReactPaginate pageCount={this.props.pendingInventories.pages}
                             pageRangeDisplayed={2}
                             marginPagesDisplayed={1}
                             previousLabel="<"
                             nextLabel=">"
                             onPageChange={this.handlePageRequest}
                             initialPage={this.state.page-1}
                             disableInitialCallback={true}
                             containerClassName="pagination"
                             pageClassName="page-item"
                             pageLinkClassName="page-link"
                             activeClassName="page-item active"
                             previousClassName="paginate_button previous"
                             nextClassName="paginate_button next"
                             disabledClassName="page-item disabled"
                             forcePage={this.state.page-1}/>
            }
          </div>
        </div>
        {this.props.pendingInventories.loading ?
          <Spinner />
        :
          null
        }
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    pendingInventories: state.pendingInventory.pendingInventoryList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPendingInventories: (page) => {
      dispatch(fetchPendingInventoryList(page)).payload.then((response) => {
        dispatch(fetchPendingInventoryListSuccess(response.data))
      }, (error) => {
        dispatch(fetchPendingInventoryListFailure(error));
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PendingInventoryListContainer));
